// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.columnMatcher_container {
  width: 348px;
  box-sizing: border-box;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  /* border: 1px solid #d8d8d8; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  padding: 10px;
  margin-bottom: 12px;
  border-radius: 5px;
  background-color: white;
  /* border-left: 5px solid #f40101; */
  min-height: 270px;

  .left {
    width: 100%;
    .column_header {
      display: flex;
      flex-direction: column;
      align-items: center;

      .column_name {
        width: 100%;
        font-size: 12px;
        font-weight: 600;
        color: #333;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          font-size: 14px;
          background-color: rgb(236, 236, 236);
          padding: 5px 15px;
          border-radius: 5px;
        }
      }

      .column_selector {
        margin-top: 10px;
        width: 100%;
      }
    }

    .column-description {
      font-size: 13px;
      color: #333;
      margin-top: 8px;
      font-family: 'Poppins-Regular', Helvetica;

      .item {
        display: flex;
        align-items: center;
      }
    }
  }
  .right {
    width: 100%;
    .header {
      font-size: 12px;
      font-weight: 500;
      color: #333;
      /* padding: 8px 0px; */
    }
    .prev_cont {
      max-height: 100px;
      position: relative;
      overflow: hidden;
      .preview_table {
        margin-top: 10px;
        padding-left: 15px;
        border-collapse: collapse;
        border-left: 1px solid #c5c5c5;
        border-top: 1px solid #c5c5c5;
        border-right: 1px solid #c5c5c5;

        .row {
          display: flex;
          font-size: 12px;
          font-weight: 500;
          color: #5d5d5d;
          border-bottom: 1px solid #c5c5c5;
          text-align: center;
          flex-wrap: wrap;
          .row_index {
            width: 30px;
            border-right: 1px solid #c5c5c5;
            background-color: #f0f0f0;
            font-size: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 500;
            line-height: 1;
            padding-top: 3px;
          }

          span {
            padding: 3px 4px;
            height: 22px;
            width: 90%;
            overflow: hidden;
            line-height: 16px;
            align-items: center;
            justify-content: center;
            font-family: 'Poppins-Regular', Helvetica;
            font-size: 13px;
          }
        }
      }
    }

    .prev_cont::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 60px;
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.738) 80%,
        rgb(255, 255, 255) 100%
      );
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CompanyAdmin/frontend-common/BulkUploader/Components/ColumnMatcher/columnmatcher.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;EACtC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;;EAEjB;IACE,WAAW;IACX;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;;MAEnB;QACE,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,WAAW;QACX,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;;QAEnB;UACE,eAAe;UACf,oCAAoC;UACpC,iBAAiB;UACjB,kBAAkB;QACpB;MACF;;MAEA;QACE,gBAAgB;QAChB,WAAW;MACb;IACF;;IAEA;MACE,eAAe;MACf,WAAW;MACX,eAAe;MACf,yCAAyC;;MAEzC;QACE,aAAa;QACb,mBAAmB;MACrB;IACF;EACF;EACA;IACE,WAAW;IACX;MACE,eAAe;MACf,gBAAgB;MAChB,WAAW;MACX,sBAAsB;IACxB;IACA;MACE,iBAAiB;MACjB,kBAAkB;MAClB,gBAAgB;MAChB;QACE,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,8BAA8B;QAC9B,6BAA6B;QAC7B,+BAA+B;;QAE/B;UACE,aAAa;UACb,eAAe;UACf,gBAAgB;UAChB,cAAc;UACd,gCAAgC;UAChC,kBAAkB;UAClB,eAAe;UACf;YACE,WAAW;YACX,+BAA+B;YAC/B,yBAAyB;YACzB,eAAe;YACf,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,gBAAgB;YAChB,cAAc;YACd,gBAAgB;UAClB;;UAEA;YACE,gBAAgB;YAChB,YAAY;YACZ,UAAU;YACV,gBAAgB;YAChB,iBAAiB;YACjB,mBAAmB;YACnB,uBAAuB;YACvB,yCAAyC;YACzC,eAAe;UACjB;QACF;MACF;IACF;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,SAAS;MACT,OAAO;MACP,QAAQ;MACR,YAAY;MACZ;;;;;OAKC;IACH;EACF;AACF","sourcesContent":[".columnMatcher_container {\n  width: 348px;\n  box-sizing: border-box;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n  /* border: 1px solid #d8d8d8; */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px;\n  margin-bottom: 12px;\n  border-radius: 5px;\n  background-color: white;\n  /* border-left: 5px solid #f40101; */\n  min-height: 270px;\n\n  .left {\n    width: 100%;\n    .column_header {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      .column_name {\n        width: 100%;\n        font-size: 12px;\n        font-weight: 600;\n        color: #333;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        span {\n          font-size: 14px;\n          background-color: rgb(236, 236, 236);\n          padding: 5px 15px;\n          border-radius: 5px;\n        }\n      }\n\n      .column_selector {\n        margin-top: 10px;\n        width: 100%;\n      }\n    }\n\n    .column-description {\n      font-size: 13px;\n      color: #333;\n      margin-top: 8px;\n      font-family: 'Poppins-Regular', Helvetica;\n\n      .item {\n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n  .right {\n    width: 100%;\n    .header {\n      font-size: 12px;\n      font-weight: 500;\n      color: #333;\n      /* padding: 8px 0px; */\n    }\n    .prev_cont {\n      max-height: 100px;\n      position: relative;\n      overflow: hidden;\n      .preview_table {\n        margin-top: 10px;\n        padding-left: 15px;\n        border-collapse: collapse;\n        border-left: 1px solid #c5c5c5;\n        border-top: 1px solid #c5c5c5;\n        border-right: 1px solid #c5c5c5;\n\n        .row {\n          display: flex;\n          font-size: 12px;\n          font-weight: 500;\n          color: #5d5d5d;\n          border-bottom: 1px solid #c5c5c5;\n          text-align: center;\n          flex-wrap: wrap;\n          .row_index {\n            width: 30px;\n            border-right: 1px solid #c5c5c5;\n            background-color: #f0f0f0;\n            font-size: 12px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            font-weight: 500;\n            line-height: 1;\n            padding-top: 3px;\n          }\n\n          span {\n            padding: 3px 4px;\n            height: 22px;\n            width: 90%;\n            overflow: hidden;\n            line-height: 16px;\n            align-items: center;\n            justify-content: center;\n            font-family: 'Poppins-Regular', Helvetica;\n            font-size: 13px;\n          }\n        }\n      }\n    }\n\n    .prev_cont::after {\n      content: '';\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      height: 60px;\n      background: linear-gradient(\n        to bottom,\n        rgba(255, 255, 255, 0) 0%,\n        rgba(255, 255, 255, 0.738) 80%,\n        rgb(255, 255, 255) 100%\n      );\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
